import { createSvgComponent } from "../../icon/createSvgComponent";
import HandHeldFill from "@core/__generated__/icon/figma/hand-held-fill.svg";
export default createSvgComponent(HandHeldFill);